export enum DIALOG_TYPES {
  EDIT_ORGANIZATION,
  DELETE_ORGANIZATION,
  LEAVE_ORGANIZATION,
  CREATE_PROJECT,
  EDIT_PROJECT,
  DELETE_PROJECT
}
